<template>
  <div class="addMaterialPurchase">
    <div class="add-content-container">
      <div class="add-titieMain">
        <div class="add-title-container">饲料采购单</div>
        <div class="add-content">
          <div class="operation-btn">
            <el-button size="small" class="del" @click="onDelete" :disabled="enableTable||!edit">删除</el-button>
            <el-button size="small" class="add" @click="onAdd" :disabled="enableTable||!edit">增加</el-button>
            <el-button size="small" class="alter" @click="onAlter" :disabled="enableTable||!edit">修改</el-button>
            <el-button size="small" class="save" v-throttle-button="onSave" :disabled="!enableTable||!edit">保存</el-button>
            <el-button size="small" class="cancel" @click="onRollBack" :disabled="!enableTable||!edit">撤销</el-button>
            <el-button size="small" class="close" @click="closeView">关闭</el-button>
          </div>
          <!-- <div :class="{'content-form-container':true,'readonly':!edit}"> -->
            <div class="custom-search-container" style="margin-top:15px;">
              <div class="custom-search-box">
                <div class="custom-search-box-warpper">
                  <span>基地</span>
                  <el-select v-model="order.fishBaseId" filterable :disabled="Boolean(orderId)||!edit" placeholder="请选择" size="small" @change="baseChange">
                    <el-option v-for="(item, index) in baseLists" :key="index" :label="item.value" :value="item.key">
                    </el-option>
                  </el-select>
                  <span>&nbsp;</span>
                  <el-select v-model="order.fishPondId" filterable :disabled="Boolean(orderId)||!edit" placeholder="请选择" size="small">
                    <el-option v-for="(item, index) in topPondList" :key="index" :label="item.value" :value="item.key">
                    </el-option>
                  </el-select>
                </div>
                <div class="custom-search-box-warpper">
                  <span style="margin-left: -25px;">新增喂养单</span>
                  <el-select v-model="order.isAddFeed" filterable placeholder="请选择" size="small">
                    <el-option label="是" :value="true"></el-option>
                    <el-option label="否" :value="false"></el-option>
                  </el-select>
                </div>
                <!-- 仓库下拉 - 暂时隐藏
                <div class="custom-search-box-warpper" v-if="$store.state.curCompany.isQlwVersion==true">
                  <span>仓库</span>
                  <el-select v-model="order.warehouseName" :disabled="!edit" filterable placeholder="请选择" size="small">
                    <el-option  v-for="(item,index) in storeHouseList" :key="index" :label="item.warehouseName" :value="item.warehouseName">
                    </el-option>
                  </el-select>
                </div>
                -->
               
                <div class="custom-search-box-warpper">
                  <span>经办人</span>
                  <el-select v-model="order.leaderId" :disabled="!edit" filterable placeholder="请选择" size="small" >
                    <el-option  v-for="item in companyUser" :key="item.id" :label="item.name" :value="item.id">
                    </el-option>
                  </el-select>
                </div>
              
              
              </div>
              <div class="custom-search-box">
               
                <div class="custom-search-box-warpper" >
                  <span>供应商</span>
                  <el-select v-model="order.providerId" :disabled="!edit" filterable placeholder="请选择" size="small" @change="providerChange">
                    <el-option v-for="(item, index) in providerList" :key="index" :label="item.value" :value="item.key">
                    </el-option>
                  </el-select>
                </div>
                 <div class="custom-search-box-warpper" >
                  <span>日期</span>
                  <el-date-picker size="small" :disabled="!edit" v-model="order.dataDate" type="date" placeholder="请选择日期" value-format="yyyy-MM-dd" :picker-options="pickerTimeOptions">
                  </el-date-picker>
                </div>
                <div class="custom-search-box-warpper" >
                  <span>单据号</span>
                  <el-input placeholder="请输入单据号" v-model="order.billsNo" size="small" disabled>
                  </el-input>
                </div>
              </div>
            </div>
          <!-- </div> -->
        </div>
      </div>
      <div class="table-container">
        <table-ex :showIndex='true' :enable="enableTable&&edit">
          <thead-ex>
            <!-- <th-ex>物资大类</th-ex> -->
            <th-ex style="width: 200px;">物资名称</th-ex>
            <th-ex>物资类别</th-ex>
            <th-ex>规格</th-ex>
            <!-- <th-ex tip="设置商品名称时,商品品类请务必选择'鲜活水产品'" class="long-td">苗种</th-ex> -->
            <th-ex>计量单位</th-ex>
            <th-ex>数量</th-ex>
            <th-ex tip="当重量为0，单价以数量为计价单价； 当重量不为0，单价为以重量计价单价" class="long-td">单价</th-ex>
            <th-ex tip="金额默认=重量*单价；当重量为0，则金额=数量*单价" class="long-td" v-if="!(Boolean(orderId)||!edit)">金额(元)</th-ex>
            <th-ex tip="用于填写折扣金额，-负数代表减少结算金额，+代表增加结算金额" class="long-td">调整金额(元)</th-ex>
            <th-ex>结算金额(元)</th-ex>
          </thead-ex>
          <tbody-ex>
            <tr-ex v-for="(item,index) in order.details" :key="index" @selected="selectedRow=item">
              <!-- <td-ex v-model="item.productTypeId" :list="bigTypeList" display="value" take="key" type='cmb'  @selected="productTypeChange(item)" ></td-ex> -->
              <td-ex v-model="item.productId" :list="productList" display="name" take="id" type='cmb'  @selected="productChange(item)" ></td-ex>
              <td-ex v-model="item.type"  type='text'></td-ex>
              <td-ex v-model="item.spec"  type='text'></td-ex>
              <td-ex v-model="item.unit" type='text'></td-ex>
              <td-ex v-model="item.quantity" type='number' @input="setMoneyAmount(item)"  number  positive></td-ex>
              <td-ex v-model="item.unitPriceTax" class="long-td"  type='number' number @input="setMoneyAmount(item)" positive :decimalLength="2"></td-ex>
              <td-ex v-model="item.amountTotal" class="long-td"  type='text' @input="setFinalAmount(item)" number v-if="!(Boolean(orderId)||!edit)"></td-ex>
              <td-ex v-model="item.amountAdjust" class="long-td"  type='number' @input="setFinalAmount(item)" number :decimalLength="2"></td-ex>
              <td-ex v-model="item.finalAmount" class="long-td"  type='text' number></td-ex>
            </tr-ex>
          </tbody-ex>
          
          <tfoot-ex v-model="order.remark" :small-change-amount.sync="order.smallChangeAmount" @addRow="addRow" @delRow="delRow">
            <td>合计</td>
            <!-- <td>--</td> -->
            <td>--</td>
            <td>--</td>
            <td>--</td>
            <td>--</td>
            <td>{{total('quantity')}}</td>
            <td>--</td>
            <td v-if="!(Boolean(orderId)||!edit)">{{total('amountTotal')}}</td>
            <td>{{total('amountAdjust')}}</td>
            <td>{{total('finalAmount')}}</td>
          </tfoot-ex>
        </table-ex>
      </div>
    </div>
  </div>
</template>


<script>
import mixins from "@/common/MixIn.js";
import { mapState, mapActions } from "vuex";
import { modules } from "../../../store";
import { MessageBox, Message } from "element-ui";
import { storage } from "../../../service/storage";
import { getDefaultLeaderId } from "@/common/leaderHelper.js";
export default {
  mixins: [mixins],
  name: "addFeedPurchase",
  data() {
    return {
            // 限制日期
      pickerTimeOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now() - 8.64e6;
        }
      },
      bigTypeList: [],
      closeBtnDisable: false,
      orderId: this.$route.query.id,
      order: {
        fishBaseId: null,
        fishPondId: null,
        leaderId: null,
        providerId: null,
        dataDate: new Date(),
        remark: "",
        details: [],
        warehouseName: "",
        billsNo: 0,
        isAddFeed: false
      },
      baseLists: [],
      providerList: [],
      fishList: [],
      enableTable: false,
      selectedRow: null,
      companyUser: [], //负责人
      productList: [], //物资名称
      storeHouseList: [], //仓库
      emptyRow: {
        productList: [], //物资名称
        productTypeId: 10001,
        productId: null, //物资名称id
        quantity: 0, //数量
        unitPriceTax: 0, //单价
        amountTotal: 0,
        amountAdjust: 0,
        finalAmount: 0
      },
      topPondList: []
    };
  },
  computed: {
    ...mapState(["loginUser"])
  },
  async mounted() {
    await this.initPagePermission();
    this.storeHouseList = await this.getStoreHouse(); //仓库
    if (this.$route.query.id) {
      document.title = this.edit ? "编辑物资采购" : "查看物资采购";
    } else {
      document.title = "增加物资采购";
      if (this.storeHouseList.length > 0) {
        this.order.warehouseId = this.storeHouseList[0].warehouseID;
        this.order.warehouseName = this.storeHouseList[0].warehouseName;
      }
    }
    // this.companyUser = await this.getEmployees(); //负责人
    // this.order.leaderId = this.loginUser.id; //负责人默认当前用户
    //供应商
    let purchaseProvide = storage.get("purchaseProvide");
    this.providerList = await this.getProviderList(); //供应商
    let oldProvider = this.providerList.find(f => f.key == purchaseProvide);
    if (!this.$route.query.id && oldProvider) {
      this.order.providerId = oldProvider.key;
      await this.providerChange(this.order.providerId);
      storage.set("purchaseProvide", this.order.providerId);
    } else if (this.providerList.length > 0) {
      this.order.providerId = this.providerList[0].key;
      await this.providerChange(this.order.providerId);
    }

    //基地
    let purchaseBase = storage.get("base");
    this.baseLists = await this.getBaseList(); //供应商
    let oldBase = this.baseLists.find(f => f.key == purchaseBase);
    if (!this.$route.query.id && oldBase) {
      this.order.fishBaseId = oldBase.key;
      await this.baseChange(this.order.fishBaseId);
    } else if (this.baseLists.length > 0) {
      this.order.fishBaseId = this.baseLists[0].key;
      await this.baseChange(this.order.fishBaseId);
    }
    this.bigTypeList = [
      {
        key: 10001,
        value: "饲料"
      },
      {
        key: 10002,
        value: "渔药"
      },
      {
        key: 10003,
        value: "疫苗"
      }
    ];
    this.getProduct2List();
    await this.getEmployeesByFishBaseList();
    this.initData();
  },

  methods: {
    ...mapActions(modules.storeHouse, {
      getStoreHouse: "getStoreHouse" //仓库
    }),
    ...mapActions(modules.materialPurchase, {
      getProductList: "getProductList", //物资名称
      addMaterialPurchase: "addMaterialPurchase", //添加
      editMaterialPurchase: "editMaterialPurchase", //获取单行数据
      updateMaterialPurchase: "updateMaterialPurchase", //更新数据
      delMaterialPurchase: "delMaterialPurchase" //删除物资
    }),
    ...mapActions(modules.user, ["getEmployees", "getEmployeesByFishBase"]), //获取负责人数据
    ...mapActions(modules.base, {
      getBaseList: "getBaseList" //基地
    }),
    ...mapActions(modules.pond, {
      getFishPond: "getFishPond" //塘口
    }),
    ...mapActions(modules.provider, {
      getProviderList: "getProviderList" //获取供应商列表
    }),
    ...mapActions(['delVisitedViews']),
    // 获取当前基地下的负责人员工列表
    async getEmployeesByFishBaseList(){
      const result = await this.getEmployeesByFishBase(this.order.fishBaseId)
      this.companyUser = result;
      this.companyUser.unshift({
        id: "",
        mobilePhone: "",
        phone: "",
        realName: "全部",
        name: "全部",
      });
      if(this.orderId) return
      this.order.leaderId = getDefaultLeaderId(result, this.loginUser && this.loginUser.name);
    },
    //总计
    total(prop) {
      let total = 0;
      this.order.details.forEach(item => (total += Number(item[prop])));
      return total.toFixed(2);
    },
    //初始化表格
    initTable() {
      this.order.details = [];
      this.$nextTick(() => this.addRow());
    },
    //初始化数据
    async initData() {
      if (!this.orderId) {
        //新增
        this.initTable();
      } else {
        //修改
        let result = await this.editMaterialPurchase(this.orderId);

        this.order.fishBaseId = result.fishBaseId;
        this.order.warehouseName = result.warehouseName;
        // this.order.isAddFeed = result.isAddFeed;
        await this.baseChange(result.fishBaseId);
        result.details.forEach(async item => {
          let as = this.bigTypeList.find(f => f.key == item.typeId);
          item.productTypeId = as.key;
          // item.productList = await this.getProductList(item.productTypeId); //物资名称列表
          item.productList = await this.getProductList(10001); // 获取饲料
          let ass = item.productList.find(f => f.id == item.productId);

          if (ass) {
            item.productId = ass.id.toString();

            item.unit = ass.unit;
            item.spec = ass.spec;
            item.type = ass.type;

            if (ass.type == 1 || ass.type == "") {
              item.type = "--";
            }
          }
          // 结算金额 = 金额 + 调整金额（finalAmount 接口未返回，用 $set 保证响应式）
          this.$set(
            item,
            "finalAmount",
            Number(
              (Number(item.amountTotal) + Number(item.amountAdjust)).toFixed(2)
            )
          );
          // 有调整金额时，库里保存的单价是 (金额+调整)/数量，已把调整摊进单价，
          // 这里还原成 金额/数量，避免再改数量时金额把调整金额重复计入
          if (
            Number(item.amountAdjust) !== 0 &&
            Number(item.quantity) > 0 &&
            Number(item.amountTotal) > 0
          ) {
            this.$set(
              item,
              "unitPriceTax",
              Number(
                (Number(item.amountTotal) / Number(item.quantity)).toFixed(2)
              )
            );
          }
        });
        this.order = result;
        this.orderId = result.id;
      }
      this.enableTable = true;
    },
    //改变基地数据
    baseChange(e) {
      storage.set("base", e);
      this.getTopPondList(e)
    },

    //供应商数据
    providerChange(id) {
      storage.set("purchaseProvide", id);
      let item = this.providerList.find(f => f.key == id);
      if (item) this.order.providerName = item.value;
    },
    //物资大类
    async productTypeChange(item) {
      item.productId = "";
      item.spec = "";
      item.unit = "";
      item.type = "";

      if (item.productTypeId && item.productTypeId !== null) {
        item.productList = await this.getProductList(10001); // 获取饲料
        // item.productList = await this.getProductList(item.productTypeId); //物资名称
        item.productId = item.productList[0] && item.productList[0].id;
        let a = item.productList.find(f => f.id == item.productId);
        if (a) {
          item.productId = a.id;
          item.unit = a.unit;
          item.type = a.type;
          item.spec = a.spec;
          console.log(1212, a.type, item.type);

          if (a.type == 1 || a.type == "") {
            item.type = "--";
          }
        }
      }
    },
    //改变物资名称--获取单位、类别
    async productChange(items) {
      let a = this.productList.find(f => f.id == items.productId);
      if (a) {
        items.productId = a.id;
        items.unit = a.unit;
        items.unitPriceTax = a.purchaseMoney;
        items.type = a.type;
        items.spec = a.spec;
        console.log(1212, a.type, items.type);

        if (a.type == 1 || a.type == "") {
          items.type = "--";
        }
        // 换了物资后单价已变，金额与结算金额要跟着重算
        this.setMoneyAmount(items);
      }
    },
    //保存
    async onSave() {
      let err = null;
      let warehouse = this.storeHouseList.find(
        f => f.warehouseName == this.order.warehouseName
      );
      if (warehouse) {
        this.order.warehouseId = warehouse.warehouseID;
      }
      if (!this.order.fishBaseId) err = "基地必须选择";
      // if (!this.order.providerId) err = "供应商必须选择";
      if (!this.order.dataDate) err = "日期必须选择";
      if (!this.order.leaderId) err = "经办人必须选择";
      // let list = this.order.details.filter(
      //   f => JSON.stringify(f) != JSON.stringify(this.emptyRow)
      // );
      let list = this.order.details.filter(f => {
        return f.productId !== "" && f.productId !== null;
      });
      let quantityReg = /^[0-9]{1,12}$/; //数量
      let unitPriceTaxReg = /^[0-9]{1,12}([.][0-9]{1,2})?$/; //单价
      let amountAdjustReg = /^-?[0-9]{1,12}([.][0-9]{1,2})?$/; //调整金额
      if (list.length == 0) err = "不能提交空表单";
      list.forEach(item => {
        if (item.unitPriceTax === 0) {
          err = "请输入单价";
        }
        if (item.quantity === 0) {
          err = "请输入数量";
        }
        if (!unitPriceTaxReg.test(item.unitPriceTax)) {
          err = "单价范围至多12位正整数,2位小数";
        }
        if (!quantityReg.test(item.quantity)) {
          err = "数量只允许输入整数";
        }
        if (!amountAdjustReg.test(item.amountAdjust)) {
          err = "调整金额范围至多12位整数,2位小数";
        }
        if (!item.productId) err = "物资名称必须选择";
      });

      if (err) {
        Message.error(err);
        return;
      }

      if (list.length > 0) this.order.details = list;
      this.order.isAddOrder = this.order.isAddFeed? 1 : 0;
      this.$nextTick(async () => {
        try {
          if (this.orderId) {
            await this.updateMaterialPurchase({
              id: this.orderId,
              data: this.order
            });
            this.$message({
              message: "保存成功",
              type: "success"
            });
          } else {
            let result = await this.addMaterialPurchase(this.order);
            this.orderId = result.id;
            this.order.billsNo = result.number;
            this.$message({
              message: "保存成功",
              type: "success"
            });
          }
          this.enableTable = false;
        } catch (error) {
          this.$Alert.info({
            content: error.response.data,
            duration: 5000,
            status: "error"
          });
          // Message.error(error.response.data);
        }
      });
    },
    onAlter() {
      this.enableTable = true;
      this.edit = true;
      if (this.orderId) {
        this.order.details.forEach(item => {
          item.pondEdit = false;
          item.fishEdit = false;
        });
      }
    },
    onAdd() {
      this.orderId = null;
      this.enableTable = true;
      this.$nextTick(async () => {
        await this.getEmployeesByFishBaseList();
        this.initData();
      });
    },
    async onDelete() {
      if (!this.orderId) {
        await this.$Alert.info({
          content: "未找到订单Id，无法删除",
          duration: 5000,
          status: "error"
        });
        // await Message.error("未找到订单Id，无法删除");
        return;
      }
      try {
        await MessageBox.confirm("是否删除此订单？", "提示");
        try {
          await this.delMaterialPurchase(this.orderId);
          this.$message({
            message: "删除成功",
            type: "success"
          });
          this.orderId = null;
          this.enableTable = true;
          this.$nextTick(() => this.initTable());
        } catch (error) {
          this.$Alert.info({
            content: error.response.data,
            duration: 5000,
            status: "error"
          });
          // this.$message.error(error.response.data);
        }
      } catch (err) {
        console.log("取消删除");
      }
    },
    onRollBack() {
      this.initData();
      this.edit = false
      this.enableTable = false
    },
    addRow() {
      let list = [];
      for (let i = 0; i < 5; i++) {
        list.push(JSON.parse(JSON.stringify(this.emptyRow)));
      }
      this.order.details = this.order.details.concat(list);
    },
    delRow() {
      this.order.details = this.order.details.filter(
        f => f != this.selectedRow
      );
    },
    // 结算金额 = 金额 + 调整金额
    setFinalAmount(item) {
      let amountTotal = Number(item.amountTotal) || 0;
      let amountAdjust = Number(item.amountAdjust) || 0;
      this.$set(
        item,
        "finalAmount",
        Number((amountTotal + amountAdjust).toFixed(2))
      );
    },
    // 金额 = 数量 × 单价；结算金额 = 金额 + 调整金额
    setMoneyAmount(item) {
      let quantity = Number(item.quantity) || 0;
      let unitPriceTax = Number(item.unitPriceTax) || 0;
      let amountAdjust = Number(item.amountAdjust) || 0;
      let amountTotal = Number((quantity * unitPriceTax).toFixed(2));
      this.$set(item, "amountTotal", amountTotal);
      this.$set(item, "finalAmount", Number((amountTotal + amountAdjust).toFixed(2)));
    },
    setquanlity(item) {},
    closeView(){
      this.delVisitedViews([{
        meta: { affix: false },
        path: this.$route.path,
        title: this.$route.meta.title,
      }])
      this.$router.replace('/buyingAndSelling/feedPurchase')
    },
    async getProduct2List(){
      this.productList = await this.getProductList(10001); // 获取饲料
    },
    // getTopPondList
    async getTopPondList(id) {
      this.topPondList = await this.getFishPond(id);
      this.topPondList.unshift({
        key: "",
        value: "全部"
      });
    },
  }
};
</script>
<style >
.danger-color {
  color: #fff;
  border-color: #dd4b39;
  background-color: #dd4b39;
}

.readonlys input {
  pointer-events: none;
  background: #f5f7fa;
}
</style>
